<!--
 * @Author: zl
 * @Date: 2021-08-21 08:52:44
 * @LastEditTime: 2022-5-12 08:54:23
 * @LastEditors: 钱磊
 * @Description: 实名认证审核
-->
<template>
	<div class="real-name-audit">
		<el-row>
			<el-form ref="realForm" :model="realForm" label-width="120px" class="form-item-bottom0" size="small">
				<template v-if="!isIdCard">
					<el-col :span="24">
						<el-col :span="6" :offset="9">
							<public-upload class="id-upload" isViewMode :viewFilesList="viewFilesList" listType="picture-card"></public-upload>
						</el-col>
					</el-col>
				</template>
				<template v-if="isIdCard">
					<el-col :span="12">
						<el-col :span="10" :offset="6">
							<public-upload ref="idcard_1" isViewMode :viewFilesList="chioseFile('idcard_1')" listType="picture-card"></public-upload>
							<div class="top-item-text2">身份证（人像面）</div>
						</el-col>
					</el-col>
					<el-col :span="12">
						<el-col :span="10" :offset="6">
							<public-upload ref="idcard_2" isViewMode :viewFilesList="chioseFile('idcard_2')" listType="picture-card"></public-upload>
							<div class="top-item-text2">身份证（国徽面）</div>
						</el-col>
					</el-col>
				</template>
				<el-col :span="12" class="mt10">
					<el-form-item>
						证件类型：
						{{ !isIdCard ? realForm.certificateTypeName : '身份证' }}
					</el-form-item>
				</el-col>
				<el-col :span="12" class="mt10">
					<el-form-item>证件编号：{{ realForm.idCard }}</el-form-item>
				</el-col>
				<el-col :span="12">
					<el-form-item>姓名：{{ realForm.userName }}</el-form-item>
				</el-col>
				<el-col :span="12">
					<el-form-item>手机号：{{ realForm.phone }}</el-form-item>
				</el-col>
				<el-col :span="12" v-if="isIdCard">
					<el-form-item>签发机关：{{ realForm.issueUnit }}</el-form-item>
				</el-col>
				<el-col :span="12" v-if="isIdCard">
					<el-form-item>有效期：{{ realForm.expiryDate }}</el-form-item>
				</el-col>
				<el-col :span="24" v-if="isIdCard && rowData.status == 0">
					<div class="red message-box">
						系统自动审核结果：<span>{{ realForm.autoResult }}</span>
					</div>
				</el-col>
				<el-col :span="12">
					<el-form-item v-if="rowData.status != 0"> 审核人：{{ rowData.auditType ? '系统自动审核' : rowData.updateUser }} </el-form-item>
				</el-col>
				<el-col :span="12">
					<el-form-item v-if="rowData.status != 0"> 审核时间：{{ rowData.updateDate }} </el-form-item>
				</el-col>
				<el-col :span="this.mode != 'view' ? 24 : 12" :class="{ 'no-bottom': rowData.status == 0 }">
					<el-form-item label="审核结果：" prop="status" v-if="rowData.status == 0" :rules="requiredRule">
						<el-select v-model="realForm.status" placeholder="请选择" :disabled="isDisabled">
							<el-option label="认证通过" :value="1"></el-option>
							<el-option label="认证失败" :value="2"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item v-else>
						审核结果：
						<span :class="{ green: rowData.status == 1, red: rowData.status == 2 }">
							{{ rowData.status === 1 ? '认证通过' : '认证失败' }}
						</span>
					</el-form-item>
				</el-col>
				<el-col :span="this.mode != 'view' ? 24 : 12" :class="{ 'no-bottom': rowData.status == 0 }">
					<el-form-item label="审核意见：" v-if="rowData.status == 0" prop="remark" :rules="requiredRule">
						<el-input
							type="textarea"
							:disabled="isDisabled"
							v-model="realForm.remark"
							maxlength="200"
							show-word-limit
							:autosize="{ minRows: 5 }"
						></el-input>
					</el-form-item>
					<el-form-item v-else> 审核意见：{{ rowData.remark }} </el-form-item>
				</el-col>
				<el-col :span="24" v-if="isIdCard && realForm.status == 1">
					<el-form-item :label="this.mode != 'view' ? '证明材料：' : ''" :class="{ fileFlex: this.mode == 'view' }">
						<span v-if="this.mode == 'view'">证明材料：</span>
						<public-upload
							tableName="apply_record"
							assortment="1111"
							:maxNum="5"
							ref="materialUpload"
							width="600px"
							:aid="rowData.id"
							:class="{ w85: this.mode == 'view' }"
							:showOtherMsg="true"
							:mode="mode"
							:needRefresh="false"
							:isDisabled="this.mode != 'view' ? false : true"
						></public-upload>
					</el-form-item>
				</el-col>
			</el-form>
		</el-row>
	</div>
</template>
<script>
import { getRecordDetail } from 'api/modules/audit'
import { auditSubmit } from 'api/modules/invoice'
import publicUpload from '@/components/w-upload/newUpload'
import { mapState } from 'vuex'
export default {
	components: { publicUpload },
	props: {
		rowData: {
			type: Object,
			deafault: () => {
				return {}
			}
		},
		mode: {
			type: String,
			default: ''
		},
		form: {
			type: String,
			default: 'main'
		}
	},
	data() {
		return {
			realForm: {
				id: '',
				certificateType: '',
				certificateTypeName: '', //证件类型
				userName: '', //姓名
				idCard: '', //证件编号
				phone: '', //手机号
				status: '', //审核结果
				remark: '' //审核意见
			},
			requiredRule: [{ required: true, message: '不能为空' }],
			btnLoading: false,
			isIdCard: false,
			viewFilesList: [] //图片的数据
		}
	},
	created() {
		if (this.form == 'main') {
			this.getMsgInfo()
		}
	},
	methods: {
		// 获取信息
		getMsgInfo() {
			getRecordDetail({
				recordId: this.rowData.id,
				id: this.rowData.id
			}).then((res) => {
				res.data.applyCertification.status = ''
				res.data.applyCertification.remark = ''
				this.realForm = res.data.applyCertification
				this.realForm.autoResult = this.rowData.autoResults
				this.viewFilesList = res.data.baseFiles
				if (res.data.applyCertification.certificateType == '1002048001') {
					//类型：身份证
					this.isIdCard = true
					this.realForm.status = this.rowData.status === 0 ? '' : this.rowData.status
					return
				}
				this.realForm.status = this.rowData.status === 0 ? '' : this.rowData.status
				this.realForm.certificateTypeName = this.dealFlatType(res.data.applyCertification.certificateType)
			})
		},

		// 判断图片类型
		chioseFile(idCardType) {
			if (idCardType == 'idcard_1') {
				return this.viewFilesList.filter((x) => x.assortment == 'idcard_1')
			} else {
				return this.viewFilesList.filter((x) => x.assortment == 'idcard_2')
			}
		},
		// 直接回显信息
		setRealInfo(data) {
			this.realForm = this.$utils.clone(data, true)
			// this.$set(this.realForm, "userName", data.userName);
			if (data.certificateType == '1002048001') {
				//类型：身份证
				this.isIdCard = true
				this.realForm.status = 1
				return
			}
			this.realForm.status = 1
		},

		// 取消
		doCancel(data) {
			this.$emit('closeReal', data)
		},

		// 处理码表回显
		dealFlatType(data) {
			let obj = this.projectDict.smzjlx.find((x) => x.value == data)
			return obj.sname
		},

		// 确认
		doSubmit() {
			this.$refs.realForm.validate((valid) => {
				if (valid) {
					this.btnLoading = true
					auditSubmit({
						id: this.rowData.id,
						busId: this.rowData.busId,
						busType: this.rowData.busType,
						status: this.realForm.status,
						remark: this.realForm.remark
					})
						.then((res) => {
							this.$message.success('审核完成')
							this.btnLoading = false
							this.doCancel('1')
						})
						.catch(() => {
							this.$emit('btnClose')
							this.btnLoading = false
						})
				} else {
					this.$emit('btnClose')
				}
			})
		}
	},
	computed: {
		...mapState('user', {
			userInfo: (state) => state.userInfo
		}),
		...mapState('dict', {
			projectDict: (state) => state.projectDict
		}),
		isDisabled() {
			return this.mode == 'view'
		}
	}
}
</script>
<style lang="less" scoped>
.real-name-audit {
	.id-upload {
		height: 150px;
		/deep/ .upload-demo .upload-text {
			vertical-align: middle !important;
		}
	}
	.top-item-text2 {
		font-size: 12px;
		line-height: 30px;
		color: #666;
		text-align: center;
		&::before {
			content: '*';
			color: #f56c6c;
			margin-right: 4px;
		}
	}
	.form-item-bottom0 {
		.el-form-item {
			margin-bottom: 5px !important;
		}
		.no-bottom {
			.el-form-item {
				margin-bottom: 15px !important;
			}
		}
	}
	.red {
		color: red;
	}
	.green {
		color: green;
	}
	.message-box {
		margin: 15px 0;
		height: 40px;
		line-height: 40px;
		background-color: #f2f2f2;
		padding-left: 20px;
	}
	.fileFlex {
		/deep/ .el-form-item__content {
			display: flex;
		}
	}
	.w85 {
		width: 85% !important;
	}
}
</style>
